import { axiosInstance as axios, handleAxiosErrors } from '_utils'
import config from '../store/_config'
import store from '../store/store'

export const updateDeliveryInfoFields = (key, value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_DELIVERY_INFO_FIELDS',
      key: key,
      value: value,
    })
    if (key !== 'DP_PreferredDeliveryDay' && key !== 'DP_PreferredDeliveryTimes') {
      const myAccountDetails = store.getState().myAccount
      if (myAccountDetails.backorderNotification.sameAsDelivery) {
        let updatedKey = key.replace('DP', 'BN')
        dispatch(updateBackorderNotificationFields(updatedKey, value))
      }
      if (myAccountDetails.featureDeals.sameAsDelivery) {
        let updatedKey = key.replace('DP', 'FD')
        dispatch(updateFeatureDealsFields(updatedKey, value))
      }
      if (myAccountDetails.accountPayable.sameAsDelivery) {
        let updatedKey = key.replace('DP', 'AP')
        dispatch(updateAccountPayableFields(updatedKey, value))
      }
    }
  }
}

export const updateBackorderNotificationFields = (key, value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_BACKORDER_NOTIFICATION_FIELDS',
      key: key,
      value: value,
    })
  }
}

export const updateFeatureDealsFields = (key, value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_FEATURES_DEALS_FIELDS',
      key: key,
      value: value,
    })
  }
}

export const updateAccountPayableFields = (key, value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_ACCOUNT_PAYABLE_FIELDS',
      key: key,
      value: value,
    })
  }
}

export const updateFieldsSameAsDelivery = (deliveryInfo = {}, objToUpdate, updateFunction) => {
  for (let [key, value] of Object.entries(deliveryInfo)) {
    if (objToUpdate.hasOwnProperty(key)) {
      updateFunction(key, value)
    }
  }
}
export const axiosCreateDeliveryInfo = (postData) => {
  let { url, query } = config.members.createMyAccountInfo
  return axios.post(
    url,
    {
      query: query,
      variables: postData,
    },
    {
      withCredentials: true,
    }
  )
}

export const axiosCreateMemberInfo = (postData) => {
  console.log('postData', postData)
  let { url, query } = config.members.createMember
  return axios.post(
    url,
    {
      query: query,
      variables: {
        Input: postData,
      },
    },
    {
      withCredentials: true,
    }
  )
}

export const axiosUpdateChileMemberInfo = (postData) => {
  console.log('postData', postData)
  let { url, query } = config.members.updateChildMemberInfo
  return axios.post(
    url,
    {
      query: query,
      variables: {
        Input: postData,
      },
    },
    {
      withCredentials: true,
    }
  )
}

export const axiosDoItLaterMemberInfo = (postData) => {
  console.log('postData', postData)
  let { url, query } = config.members.updateDoItLaterCountMemberInfo
  return axios.post(
    url,
    {
      query: query,
      variables: {
        Input: postData,
      },
    },
    {
      withCredentials: true,
    }
  )
}
export const axiosDeleteChildMemberInfo = (postData) => {
  console.log('postData', postData)
  let { url, query } = config.members.deleteMemberMutation
  return axios.post(
    url,
    {
      query: query,
      variables: {
        ID: postData,
      },
    },
    {
      withCredentials: true,
    }
  )
}
